export var extensions = ['', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'png', 'jpg', 'jpeg', 'pps', 'ppt', 'pptx'];
var validExtensions = {
  word: ['doc', 'docx', 'docm', 'odt', 'ott', 'fodt'],
  excel: ['xls', 'xlsx', 'xlsm', 'xlsb', 'xlam', 'ods', 'ots', 'fods'],
  powerpoint: ['ppt', 'pptx', 'pptm', 'ppam', 'ppsx', 'ppsm', 'sldx', 'sldm', 'odp', 'otp', 'fodp'],
  pdf: ['pdf'],
  image: ['png', 'jpg', 'jpeg', 'tif', 'tiff', 'odi'],
  video: ['asf', 'vfw', 'avi', 'mp4', 'mpg4', 'm4v', 'mov', 'mpg', 'mpeg', 'mpe', 'm75', 'm15', 'm2v', 'ts', 'qt', 'div', 'wmv', 'mkv'],
  archive: ['zip', 'rar', '7z']
};
var getExtensionIcon = function getExtensionIcon(extension) {
  var types = Object.keys(validExtensions);
  var type = types.filter(function (t) {
    return validExtensions[t].some(function (ext) {
      return ext === extension;
    });
  });
  return "file " + (type || 'alternate') + " outline";
};
export default getExtensionIcon;